<template>
  <div>
    <TabList
      v-slot:default="{item, index, selected, hover}"
      :items="tabs"
      :value="currentTab"
      @input="goToFolder"
    >
      <div class="d-flex justify-content-between">
        <!-- <a href="" is="router-link" :to="item.path"> -->
        <div
          :style="{opacity: (hover || selected)? 1:0.5, 'font-weight': (selected)?'bold': ''}"
        >
          <font-awesome-icon
            class="folder-selector-list__icon"
            icon="circle"
          />
          {{ (item.title)?item.title:'Untitled' }}
          <em v-if="index != 0">({{ item.folder.files_count }})</em>
          <em v-else>({{ allItemsCount }})</em>
        </div>
        <!-- </a> -->
        <font-awesome-icon
          v-if="item.folder"
          :class="`delete_icon ${hover ? 'hover' : ''}`"
          icon="trash"
          @click="folderToDelete = item.folder; showDeleteFolderModal = true"
        />
      </div>
    </TabList>
    <hr>
    <FolderCreate class="ml-2" />
    <baseModal
      id="deleteCollateralFolder"
      size="sm"
      title="Delete Folder"
      :show="showDeleteFolderModal"
      @closed="showDeleteFolderModal = false; folderToDelete = null"
    >
      <label for>Are your sure you want to delete
        <span v-if="folderToDelete"><em>'{{ folderToDelete.name }}'</em></span>
        <span v-else>this folder</span>?
      </label>
      <div v-if="folderToDelete && folderToDelete.files_count">
        <strong>This operation will permanently delete {{ folderToDelete.files_count }} file{{ folderToDelete.files_count === 1 ? '' : 's' }}</strong>
      </div>
      <template slot="footer">
        <baseButton
          inverse
          :disabled="deletingFolder"
          @click="deleteFolder(folderToDelete)"
        >
          <div v-if="!deletingFolder">
            Confirm
          </div>
          <font-awesome-icon
            v-else
            icon="spinner"
            spin
          />
        </baseButton>
      </template>
    </baseModal>
  </div>
</template>

<script>
export default {
  name: 'FolderSelectorList',
  data() {
    return {
      selected: '',
      showDeleteFolderModal: false,
      folderToDelete: null,
      deletingFolder: false,
    };
  },
  computed: {
    currentTab() {
      if (this.$route.params.folderId === undefined) return 0;
      let index = this.items.findIndex(
        (i) => i.pk === Number(this.$route.params.folderId),
      );
      if (index === -1) {
        index = 0;
      }
      return index + 1;
    },
    tabs() {
      const tabs = this.items.map((i) => ({
        path: `/collateral/folder/${i.pk}`,
        title: i.name,
        folder: i,
      }));

      tabs.unshift({
        path: '/collateral/',
        title: 'All',
        folder: null,
      });

      return tabs;
    },
    items() {
      return this.$store.state.folders.items;
    },
    allItemsCount() {
      return this.items.map((folder) => folder.files_count).reduce((a, b) => Number(a) + Number(b), 0);
    },
  },
  watch: {
    selected() {
      console.log(this.selected);
      if (this.selected) {
        this.$router.push(`/collateral/folder/${this.selected.pk}`);
      } else {
        this.$router.push('/collateral/');
      }
    },
    '$store.state.folders.isLoading': {
      handler(newval) {
        if (newval === false && this.deletingFolder) {
          this.deletingFolder = false;
          this.showDeleteFolderModal = false;
          this.folderToDelete = null;
          this.goToFolder(0);
        }
      },
    },
  },
  mounted() {
    this.$store.dispatch('folders/getAll');
  },
  methods: {
    goToFolder(index) {
      this.$router.push(this.tabs[index].path);
    },
    deleteFolder(folder) {
      console.log('Deleting folder ', folder.name);
      this.deletingFolder = true;
      this.$store.dispatch('folders/deleteItem', folder.pk);
    },
  },
};
</script>

<style lang="scss" scoped>
.router-link-exact-active{
    font-weight: bold;
}
.folder-selector-list{
    list-style: none;
    margin: 0;
    padding: 0;
    &__icon{
        font-size: 5px;
        margin-right: 0.5rem;
        color: rgba(black, 0.2);
    }
    li{
        // border-bottom: solid 1px #ccc;
        a{
            display: block;
            padding-left: 0.2rem;
            font-size: 0.9rem;
        }
    }
}
</style>
<style scoped>
.delete_icon {
    opacity: 0;
    transition: opacity .3s ease;
}
.delete_icon.hover {
    opacity: 1;
}
</style>
